import type { PhieuThuDetailRow, ReceiptCellValue } from '../types';
import type { PhieuThuInvoiceLookup } from '@/types/schemas';
import { roundNumber } from '@/lib/formatUtils';

/**
 * Calculate totals from detail rows for PhieuThu (Receipt Voucher)
 * Uses actual field names from PhieuThu DetailTab
 */
export const calculateTotals = (detailRows: PhieuThuDetailRow[] = []) => {
  const t_tien_nt = detailRows.reduce(
    (sum: number, row) => sum + Number(row.tien_nt || row.id_hd_data?.tien_hd_nt || 0),
    0
  );

  return {
    t_tien_nt: roundNumber(t_tien_nt, 4),
    t_tien: roundNumber(t_tien_nt, 4)
  };
};

export const handleUpdateRowFields = (row: PhieuThuDetailRow, field: string, newValue: ReceiptCellValue) => {
  if (field === 'id_hd_data' || field === 'ma_thue_data' || field === 'tien_nt') {
    const invoiceValue =
      typeof newValue === 'object' && newValue && 'tien_tren_hd' in newValue
        ? (newValue as PhieuThuInvoiceLookup)
        : null;
    const taxValue = typeof newValue === 'object' && newValue && 'thue_suat' in newValue ? newValue : null;
    const tien_nt = Number(
      field === 'id_hd_data' ? invoiceValue?.tien_tren_hd : field === 'tien_nt' ? newValue : row.tien_nt
    );
    const tk_co_data = field === 'id_hd_data' ? invoiceValue?.tk_data : row.tk_co_data;
    const thue_suat = Number(field === 'ma_thue_data' ? taxValue?.thue_suat : row.thue_suat) || 0;
    const thue_nt = roundNumber((tien_nt * thue_suat) / 100, 4);
    return {
      tien_nt: roundNumber(tien_nt, 4),
      thue_suat: roundNumber(thue_suat, 4),
      thue_nt,
      tk_co_data
    };
  }
  return {};
};

/**
 * Example usage and test cases for the calculation functions
 *
 * Test the exchange rate calculations:
 * - calculateTienFromTienNt(100, 24000) should return 2400000 (100 USD * 24000 VND/USD)
 * - calculateTienNtFromTien(2400000, 24000) should return 100 (2400000 VND / 24000 VND/USD)
 * - handleUpdateRowFields(row, 'tien_nt', 100, 24000) should return { tien: 2400000 }
 */
